import dayjs from 'dayjs';

export const formatGoogleCalendarLink = (
  eventTitle: string,
  timeZone: string,
  startDate: string,
  endDate?: string,
): string => {
  // Adjustment for a strange Google Calendar bug that adds 5 minutes if there is an accompanying timezone
  const subtractMinutesTime = 5;
  const formattedStartTime = dayjs(startDate).subtract(subtractMinutesTime, 'minute').format('YYYYMMDDTHHmm');
  const formattedEndTime = dayjs(endDate).subtract(subtractMinutesTime, 'minute').format('YYYYMMDDTHHmm');

  const dates = endDate ? `${formattedStartTime}/${formattedEndTime}` : `${formattedStartTime}/${formattedStartTime}`;

  const baseUrl = 'https://www.google.com/calendar/event?action=TEMPLATE';
  return `${baseUrl}&text=${eventTitle}&dates=${dates}&ctz=${timeZone}`;
};
